import { FileState, IFile } from '@/types';
import { ReactNode } from 'react';
import Loader from '../Loader';
import CheckCircleFill from '../icons/Action/CheckCircleFill';
import ErrorFill from '../icons/Action/ErrorFill';
import Trash from '../icons/Action/Trash';
import Cross from '../icons/Cross';
import Contract from '../icons/Document/Contract';
import styles from './styles.module.scss';

const FileStatus: React.FC<{
  file: IFile;
  onFileDelete: (name: string) => void;
}> = ({ file, onFileDelete }) => {
  function renderIcon(): ReactNode {
    switch (file.state) {
      case FileState.ERROR:
        return <ErrorFill />;
      case FileState.FILLED:
        return <CheckCircleFill />;
      case FileState.LOADING:
        return <Loader />;
      default:
        return <Contract />;
    }
  }
  function previewFile() {
    // We generate the blob using the file type
    const blob = new Blob(Array.of(file.file), {
      type: `${file.file.type};base64`,
    });
    console.log(blob, file);
    // We create the file URL from the Blob
    const pdfObjectUrl = URL.createObjectURL(blob);

    // We open the url in a new window
    window.open(pdfObjectUrl);
  }
  function renderDeleteIcon(): ReactNode {
    switch (file.state) {
      case FileState.ERROR:
        return <Cross onClick={() => onFileDelete(file.file.name)} />;
      case FileState.LOADING:
        return <Cross onClick={() => onFileDelete(file.file.name)} />;
      case FileState.FILLED:
        return (
          <>
            <a onClick={previewFile}>Voir</a>
            <Trash onClick={() => onFileDelete(file.file.name)} />
          </>
        );
      default:
        return (
          <>
            <a onClick={previewFile}>Voir</a>
            <Trash onClick={() => onFileDelete(file.file.name)} />
          </>
        );
    }
  }

  return (
    <div className={`flex-column gap-xs`}>
      <div
        className={`flex-row gap-s ${styles.status} ${
          file.state === FileState.ERROR ? styles.error : ''
        }`}
      >
        <div className={`flex-row gap-s ${styles.filename}`}>
          {renderIcon()}
          <p>{file.file.name}</p>
        </div>
        <div className={`flex-row gap-s ${styles.filesettings}`}>
          {renderDeleteIcon()}
        </div>
      </div>
      <p className="s">{file.error}</p>
    </div>
  );
};

export default FileStatus;
